import gql from 'graphql-tag';

export const getTeamLevelGoals = gql`
  query GetTeamLevelGoals($userID: String!) {
    getTeamLevelGoals(userID: $userID) {
      coachingIDs
      createdBy
      description
      endDate
      justification
      justificationUserName
      justificationTime
      level
      metric
      outcome
      periodType
      periodValue
      status
      targetValue
      userID
      userName
      goalID
    }
  }
`;

export const getAssociateLevelGoals = gql`
  query GetAssociateLevelGoals($associates: [String!]!, $userID: String!) {
    getAssociateLevelGoals(associates: $associates, userID: $userID) {
      coachingIDs
      createdBy
      description
      endDate
      goalID
      justification
      justificationUserName
      justificationTime
      level
      metric
      outcome
      periodType
      periodValue
      status
      targetValue
      userID
      userName
    }
  }
`;
